'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

interface Props {
  fallbackHref?: string
  fallbackLabel?: string
}

export default function BackButton({
  fallbackHref = '/blog',
  fallbackLabel = 'Back to all posts',
}: Props) {
  const router = useRouter()
  const [canGoBack, setCanGoBack] = useState(false)

  useEffect(() => {
    // window.history.length > 1 means there is at least one previous entry
    // we can return to within this tab's session.
    setCanGoBack(typeof window !== 'undefined' && window.history.length > 1)
  }, [])

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (canGoBack) {
      e.preventDefault()
      router.back()
    }
  }

  return (
    <Link
      href={fallbackHref}
      onClick={handleClick}
      className="after:hidden inline-flex items-center gap-2 text-sm text-white/55 hover:text-white transition-colors"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-transform group-hover:-translate-x-0.5"
        aria-hidden
      >
        <path
          d="M8.5 11L4.5 7L8.5 3"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{canGoBack ? 'Back' : fallbackLabel}</span>
    </Link>
  )
}
